
import { Component } from 'react'

import { SupportingDocumentationQuestionnaire } from '../../../../../../../lib/Questionnaires'
import {
  YesNoRadioOptions,
  bindTargetMixin,
  CancelButton,
  escapeCancel,
  QuestionRadioButtonInput,
  SaveButton
} from '../../../../../../shared/FormBuilder'
import { Paper } from '../../../../../../shared/NarusMaterial'

import { style } from './style'

class LivingWill extends bindTargetMixin(Component) {
  constructor (props) {
    super(props)
    this.state = {
      value: { ...props.value }
    }
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
  }

  getValues () {
    return { ...this.state.value }
  }

  handleFormSubmit () {
    const { handleSubmit } = this.props
    handleSubmit(this.getValues())
    this.setState({
      isSubmitting: true
    })
  }

  handleKeyDown (e) {
    escapeCancel(e, this.props.cancel)
  }

  render () {
    const documentation =
      this.state.value.LWHave === 'yes' && !this.state.value.LWNarusCopy

    const disableSave = !this.state.value.LWHave || documentation

    return (
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      <form
        onKeyDown={this.handleKeyDown}
        className='margin-top margin-bottom col-xs-12'
      >
        <Paper>
          <h2 className='col-xs-12'> Living Will </h2>

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.LWHave}
            required
          />

          <div
            className='col-xs-12 margin-top'
            style={style.subHead}
          >
            {' '}
            If, yes?
          </div>

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.LWNarusCopy}
            required={this.state.value.LWHave}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.LWChanges}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.LWCopies}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.LWQuestions}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.LWSendCopies}
          />

          <div
            className='col-xs-12 margin-top'
            style={style.subHead}
          >
            {' '}
            If, no?
          </div>

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.LWLearning}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.LWComplete}
          />

          <div
            className='row margin-top end-xs'
            style={style.marg}
          >
            <div className='col-xs-offset-8 col-xs-4'>
              <CancelButton onClick={this.props.cancel} />
              <SaveButton
                disabled={disableSave || this.state.isSubmitting}
                onClick={this.handleFormSubmit}
              />
            </div>
          </div>
        </Paper>
      </form>
    )
  }
}

export default LivingWill
